import { PlannerProfileListSearchCriteria } from '../../../../models';

export class ShipmentPlannerProfileListLoad {
  public static readonly type = '[ShipmentPlannerProfileList] Load';
  constructor(public payload: PlannerProfileListSearchCriteria) {}
}

export class ShipmentPlannerProfileListInitialState {
  public static readonly type = '[ShipmentPlannerProfileList] Set Initial State';
}
